let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("iM4G2")).then(() => parcelRequire('2Z7LQ'));